import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { lineClamp } from '@helpers/global';
import { Device, from } from '@helpers/media';
import { ReactComponent as SvgArrow } from '@img/icons/chevron-right.svg';
import { ReactComponent as SvgExternal } from '@img/icons/external-link.svg';
import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import { m } from 'framer-motion';
import styled, { css } from 'styled-components';
const Container = styled(m.nav) `
  ${setCssVar('accentColor', brand.hta.greenLight)};
  ${setCssVar('accentColorAlt', brand.grey)};
  ${setCssVar('bgColor', brand.white)};
  ${setCssVar('fgColor', brand.black)};
  ${setCssVar('fgColorAlt', brand.black)};

  .theme-apl & {
    ${setCssVar('accentColor', brand.apl.greenLight)};
    ${setCssVar('accentColorAlt', brand.grey)};
    ${setCssVar('bgColor', brand.white)};
    ${setCssVar('fgColor', brand.black)};
    ${setCssVar('fgColorAlt', brand.black)};
  }

  .theme-hh & {
    ${setCssVar('accentColor', brand.hortHouse.greenLight)};
    ${setCssVar('accentColorAlt', brand.white)};
    ${setCssVar('bgColor', brand.hortHouse.greyMid)};
    ${setCssVar('fgColor', brand.white)};
    ${setCssVar('fgColorAlt', brand.black)};
  }

  .theme-rss & {
    ${setCssVar('accentColor', brand.rss.greyLight)};
    ${setCssVar('accentColorAlt', brand.black)};
    ${setCssVar('bgColor', brand.rss.grey)};
    ${setCssVar('fgColor', brand.white)};
    ${setCssVar('fgColorAlt', brand.white)};

    height: calc(100vh - 73px);
  }

  display: flex;
  background: ${cssVar('bgColor')};
  flex-direction: column;
  margin: 0;
  padding: 20px 0 0;

  @media ${from(Device.TabletLarge)} {
    display: none;
  }
`;
const BackButton = styled.button `
  display: flex;
  align-items: center;
  background: none;
  border: 0;
  color: ${cssVar('accentColorAlt')};
  font-size: 16px;
  height: 20px;
  line-height: 22px;
  margin: 0 0 10px;
  padding: 0 18px;
  text-align: left;
  text-transform: uppercase;

  &:focus,
  &:hover {
    background: none;
    border: 0;
  }
`;
const BackArrow = styled(SvgArrow) `
  display: inline-block;
  margin: 0 8px 0 0;
  transform: translateY(-1px) rotate(180deg);
  height: 17px;
  width: 10px;
`;
const Title = styled.a `
  ${fonts.sourceSansPro.semiBold};
  display: flex;
  align-items: center;
  color: ${cssVar('fgColor')};
  height: 40px;
  font-size: 18px;
  line-height: 22px;
  padding: 0 18px 0;
  text-align: left;
  text-decoration: none;

  &:hover {
    background: ${cssVar('accentColor')};
    border: 0;
    color: ${cssVar('fgColorAlt')};
  }
`;
const LinkHolder = styled.div `
  display: flex;
  flex-wrap: wrap;
`;
const LinkDescription = styled.p `
  ${lineClamp(2, 'block')};
  ${fonts.sourceSansPro.regular};
  font-size: 16px;
  line-height: 22px;
  margin-top: 8px;
  color: ${cssVar('accentColorAlt')};
  width: 100%;
`;
const Item = styled.div `
  display: block;
  flex: 1 0 100%;
  padding: 0;
  margin: 0 0 3px;
  overflow: hidden;
  position: relative;

  ${({ hasImage }) => hasImage &&
    css `
      flex: 0 0 50%;

      ${ItemLink} {
        padding: 8px 18px;
      }
    `}
`;
const AccountItem = styled(Item) `
  opacity: 0.7;
`;
const linkStyles = css `
  ${fonts.sourceSansPro.semiBold};
  display: block;
  align-items: center;
  border: 0;
  background: ${cssVar('bgColor')};
  color: ${cssVar('fgColor')};
  font-size: 18px;
  line-height: 25px;
  margin: 0;
  min-width: 0;
  padding: 8px 36px 8px 18px;
  text-align: left;
  text-overflow: ellipsis;
  width: 100%;

  &:focus,
  &:hover {
    background: ${cssVar('accentColor')};
    border: 0;
    color: ${cssVar('fgColorAlt')};

    ${LinkDescription} {
      color: ${cssVar('fgColorAlt')};
    }
  }
`;
const ItemButton = styled.button `
  ${linkStyles}
  position: relative;
`;
const ItemLink = styled.a `
  ${linkStyles}
  text-decoration: none;
`;
const ItemArrow = styled(SvgArrow) `
  position: absolute;
  top: 50%;
  right: 18px;
  transform: translateY(-50%);
  margin-left: auto;
  height: 17px;
  width: 10px;

  &[data-show='false'] {
    display: none;
  }
`;
const External = styled(SvgExternal) `
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  display: block;
  height: 17px;
  width: 17px;
`;
const Border = styled.hr `
  width: calc(100% - 36px);
  border: 1px solid ${brand.greyVeryLight};
`;
const BgImageHolder = styled.div `
  width: 100%;
  height: 120px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
`;
const BgImage = styled.img `
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  width: 100%;
`;
const ContentHolder = styled.div ``;
const NavBase = styled.div ``;
const NavCtaHolder = styled.div `
  padding: 35px 18px 25px;
`;
const TopLinkHolder = styled.div `
  padding: 25px 18px 10px;
  width: 100%;
`;
const TopLinkList = styled.div `
  display: block;
`;
const TopLinkItem = styled.a `
  display: block;
  ${fonts.sourceSansPro.regular};
  font-size: 16px;
  line-height: 22px;
  text-decoration: none;
  margin-bottom: 10px;
  color: ${cssVar('accentColorAlt')};
`;
const CtaBtn = styled(LinkButton) `
  margin-right: 20px;
  min-width: 100px;
`;
const AccountBtnArea = styled.div `
  padding: 19px 19px 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;
export default {
    AccountBtnArea,
    AccountItem,
    BackArrow,
    BackButton,
    BgImage,
    BgImageHolder,
    Border,
    ContentHolder,
    Container,
    CtaBtn,
    External,
    Item,
    ItemArrow,
    ItemButton,
    ItemLink,
    LinkDescription,
    LinkHolder,
    NavBase,
    NavCtaHolder,
    Title,
    TopLinkHolder,
    TopLinkItem,
    TopLinkList,
};
